import './polyfills'

import { runApp } from './runApp'

runApp()
